var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBhim(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 26,
    viewBox: "0 0 17 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 26,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2_362",
    transform: "scale(0.0588235 0.0384615)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2_362",
    width: 17,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAaCAYAAABRqrc5AAACRklEQVRIDbWUX0hTURzHL6zUkESwUERKxSd9MjAlSYLefCzpIagXBUFIhoR/SoYutoJt6hLpIbIHqSSCQIx0ILUQEZUQRH1wzFqBDM2BsHTt7n77nXN3793dnXGFdeDecw73fD98z/n+zhWQhSZkgYH/DPG7ACnBjUb/HOIgFj3WdGYn8SNg8BywOc2Fs9uLsM0/OyFk+wvQQ3xvLZAQ0fVpGIXea9j9HckIyuxkpg/oo0+9AqTVN6gZvwXBfRndn71mIRI5uAQ8IAg9+85S5A5dgeBpQP7IVfw8CBtARieREIktKoQ5anNUcojgrkeH74kJyMpLvg3FCeu/9efgDG2HuWGuApEfOpDRyUSL5iK5JebG6riourn7wfYPSPwQsBcZIQTbeXgaZ911HHSKHK3tBlSQ3kkwGa3iILUnN+2OCtXNjff3IUkUAjU9ZKZXjjZVzMYEeDVQhDw6WHYuLO7G162IifE0CKOOUHFlADy1F8PCxElA87tO3TXQnKRHSzCJnoFHZbKYAVx1uDPdjyMxxh0oLw2yPK6LViTAPUe5DmCdc0FMyJdSAbBeg0zcVLcSo2K77azSAHQG9oXnqTrdWIbQVVejtRXAN/eYW2dnYPHUY+zrW50ofSJDgn751g6eB0KLsNKtZSWeR9U5uTmbrjHMZchHitZ5AQhv8OyrX7SgwNsEH/1HzDSKgA6KlXrkO1+/tR9Cyeh1LO2sm9HzNQJYXNFfqmAq4MfGXlCdmxlo6SRXK6VsRqysMUCUDyfpswL5C0Ga8dOoHf5JAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhim);
export default __webpack_public_path__ + "static/media/bhim.dbe35e4a1398c0255d8a58a634c9c224.svg";
export { ForwardRef as ReactComponent };